module.exports = __webpack_public_path__ + "img/android2icon4.4b242d7c.png";